import { render, staticRenderFns } from "./CrmUpdate.vue?vue&type=template&id=722c154a&scoped=true"
import script from "./CrmUpdate.vue?vue&type=script&lang=js"
export * from "./CrmUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c154a",
  null
  
)

export default component.exports